var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input-container",
      class: { "required-fail": _vm.requiredFail },
      staticStyle: { position: "relative" }
    },
    [
      _c("input", {
        attrs: { type: "date", disabled: _vm.disabled },
        domProps: { value: _vm.getDate },
        on: {
          input: function($event) {
            return _vm.updateDate($event.target.value)
          }
        }
      }),
      _vm._v(" "),
      !_vm.disabled && !_vm.required && _vm.value
        ? _c(
            "v-btn",
            {
              staticClass: "form-input-clear-button",
              attrs: { "x-small": "", text: "", icon: "" },
              on: {
                click: function($event) {
                  return _vm.updateValue(null)
                }
              }
            },
            [
              _c("v-icon", { attrs: { size: "15" } }, [
                _vm._v("\n      clear\n    ")
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f5ea6de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f5ea6de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Npv/Configuration/components/InputTypesNPV/InputTypeDateNPV.vue
// module id = null
// module chunks = 